const httpLib = require('./http-library.js');
const publicConfig = require('../public-config.js');
const btoa = require('btoa');

const ssoHost = publicConfig.external_address;

exports.Session = {
  createSocial: function createSocial (username, provider, providerId, socialAccessToken, callback) {
    const loginBody = {
      grant_type: 'social_login',
      provider: provider,
      social_access_token: socialAccessToken
    };

    if (providerId) {
      loginBody.provider_id = providerId;
    }

    if (username) {
      loginBody.username = username;
    }


    const request_params = {
      host: ssoHost,
      path: '/web-2/v1/sso/authenticate',
      method: 'POST'
    };

    httpLib.request(request_params, function (response) {
      callback(response);
    }, loginBody);
  },

  create: function createSession (username, pw, callback) {
    const loginBody = {
      username: username,
      password: pw,
      grant_type: 'password'
    };

    const request_params = {
      host: ssoHost,
      // routing through webtemplates
      path: '/web-2/v1/sso/authenticate',
      method: 'POST'
    };

    httpLib.request(request_params, function (response) {
      callback(response);
    }, loginBody);
  },

  destroy: function destroySession (token, callback) {
    const request_params = {
      host: ssoHost,
      path: '/v1/sso/users/logout/',
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    httpLib.request(request_params, function (response) {
      callback(response);
    });
  },

  checkGrants: function checkGrants (username, token, callback, socialId) {
    function encodeData (data) {
      return Object.keys(data).map((key) => {
        return [key, data[key]].map(encodeURIComponent).join('=');
      }).join('&');
    }

    const request_params = {
      host: ssoHost,
      path: '/v1/sso/grants',
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    const queryParams = {};

    const facebookId = socialId && socialId.facebook;
    if (facebookId) queryParams.facebook_id = socialId.facebook;
    if (socialId && socialId.google) queryParams.google_id = socialId.google;

    // building out the request path
    const usernameParam = !facebookId ? `?username=${btoa(username)}` : '?';
    const encodedQueryParams = encodeData(queryParams);
    const encodedParams = encodedQueryParams ? `${!facebookId ? '&' : ''}${encodedQueryParams}` : '';

    request_params.path = `${request_params.path}${usernameParam}${encodedParams}`;

    httpLib.request(request_params, function (response) {
      callback(response);
    });
  }
};

exports.SSO = {
  createPWReset: function createPWRequest (username, callback) {
    const pwResetBody = {
      username: username,
      grant_type: 'password_reset'
    };

    const request_params = {
      host: ssoHost,
      // routing through webtemplates
      path: '/web-2/v1/sso/authorize',
      method: 'POST'
    };

    httpLib.request(request_params, function (response) {
      callback(response);
    }, pwResetBody);
  },

  createSocial: function createSocial (username, provider, providerId, socialAccessToken, callback) {
    const signupBody = {
      grant_type: 'social_signup',
      username: username,
      provider: provider,
      provider_id: providerId,
      social_access_token: socialAccessToken
    };

    const request_params = {
      host: ssoHost,
      path: '/web-2/v1/sso/authenticate',
      method: 'POST'
    };

    httpLib.request(request_params, function (response) {
      callback(response);
    }, signupBody);
  },

  updatePassword: function updatePW (token, callback) {
    const request_params = {
      host: ssoHost,
      path: '/v1/sso/users/password/',
      method: 'PUT',
      headers: {
        Authorization: 'Bearer ' + token
      }
    };

    httpLib.request(request_params, function (response) {
      callback(response);
    });
  }
};
